import z from 'zod';

import { legalEntityRelationValidator, socialContractFileItemSchema, SKIPPABLE_DOCUMENT_STATUSES } from './registry';

export const cnhValidator = z.object({
  documentType: z.literal('cnh'),
  signerDocument: z.string().min(1, 'O CPF é obrigatório'),
  documentHash: z.string().min(1, 'O documento é obrigatório'),
  documentBackHash: z.string().optional(),
  selfieHash: z.string().min(1, 'Selfie hash is required'),
  documentStatus: z.enum(SKIPPABLE_DOCUMENT_STATUSES),
  legalEntityRelation: legalEntityRelationValidator.optional()
});

export type CNHAnalyzerInput = z.infer<typeof cnhValidator>;

export const rgValidator = z.object({
  documentType: z.literal('rg'),
  signerDocument: z.string().min(1, 'O CPF é obrigatório'),
  documentFrontHash: z.string().min(1, 'O documento da frente é obrigatório'),
  documentBackHash: z.string().optional(),
  selfieHash: z.string().min(1, 'Selfie hash is required'),
  documentStatus: z.enum(SKIPPABLE_DOCUMENT_STATUSES),
  legalEntityRelation: legalEntityRelationValidator.optional()
});

export type RGAnalyzerInput = z.infer<typeof rgValidator>;

export const cinValidator = z.object({
  documentType: z.literal('cin'),
  signerDocument: z.string().min(1, 'O CPF é obrigatório'),
  documentFrontHash: z.string().min(1, 'O documento da frente é obrigatório'),
  documentBackHash: z.string().optional(),
  selfieHash: z.string().min(1, 'Selfie hash is required'),
  documentStatus: z.enum(SKIPPABLE_DOCUMENT_STATUSES),
  legalEntityRelation: legalEntityRelationValidator.optional()
});

export type CINAnalyzerInput = z.infer<typeof cinValidator>;

export const passportValidator = z.object({
  documentType: z.literal('passport'),
  signerDocument: z.string().min(1, 'O CPF é obrigatório'),
  documentHash: z.string().min(1, 'O documento é obrigatório'),
  selfieHash: z.string().min(1, 'Selfie hash is required'),
  documentStatus: z.enum(SKIPPABLE_DOCUMENT_STATUSES),
  legalEntityRelation: legalEntityRelationValidator.optional()
});

export type PassportAnalyzerInput = z.infer<typeof passportValidator>;

export const documentAnalyzerInput = z.union([cnhValidator, rgValidator, cinValidator, passportValidator]);
export type DocumentAnalyzerInput = z.infer<typeof documentAnalyzerInput>;

export const analyzeDocumentValidator = z.discriminatedUnion('documentType', [
  cnhValidator,
  rgValidator,
  cinValidator,
  passportValidator
]);

export type AnalyzeDocumentInput = z.infer<typeof analyzeDocumentValidator>;

export const analyzeSocialContractValidator = z.object({
  socialContractFiles: z
    .array(socialContractFileItemSchema)
    .min(1, 'Pelo menos um arquivo de contrato social deve ser enviado')
});

export type AnalyzeSocialContractInput = z.infer<typeof analyzeSocialContractValidator>;

export const errorObjectValidator = z.object({
  code: z.string(),
  message: z.string(),
  details: z.string().optional()
});

export type ErrorObject = z.infer<typeof errorObjectValidator>;

export const documentAnalysisResult = z.object({
  errors: z.array(errorObjectValidator)
});
